import { useEffect, useState } from "react";
import { LeaveAPI } from "../../api/leave";
import SearchableUserSelect from "../../components/SearchableUserSelect";

function formatLeaveYear(year) {
  return `${year}/${String(year + 1).slice(-2)}`;
}

export default function AdminLeaveAllowancesPage() {
  const [users, setUsers] = useState([]);
  const [userId, setUserId] = useState(null);
  const [year, setYear] = useState(new Date().getFullYear());
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadUsers();
  }, []);

  useEffect(() => {
    if (userId && year) {
      loadAllowances();
    }
  }, [userId, year]);

  async function loadUsers() {
    const token = localStorage.getItem("lumat_token");

    const res = await fetch("/api/users", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    const data = await res.json();

    setUsers(Array.isArray(data) ? data : data.users || []);
  }

  async function loadAllowances() {
    setLoading(true);
    try {
      const data = await LeaveAPI.adminAllowances(userId, year);
      setRows(data);
    } finally {
      setLoading(false);
    }
  }

  async function saveRow(row) {
    await LeaveAPI.saveAllowance({
      user_id: userId,
      leave_type_id: row.leave_type_id,
      leave_year: year,
      allowance_days: Number(row.allowance_days || 0),
      carry_over_days: Number(row.carry_over_days || 0),
    });

    await loadAllowances();
  }

  function updateRow(index, field, value) {
    const copy = [...rows];
    copy[index] = { ...copy[index], [field]: value };
    setRows(copy);
  }

  return (
    <div className="p-4 space-y-4">
      <h1 className="text-xl font-semibold">Leave Allowances</h1>

      {/* Filters */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm mb-1">User</label>
          <SearchableUserSelect
            users={users}
            value={userId}
            onChange={setUserId}
          />
        </div>

        <div>
          <label className="block text-sm mb-1">Leave Year</label>
          <input
            type="number"
            className="border p-2 w-full"
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
          />
          <div className="text-xs text-gray-500 mt-1">
            {formatLeaveYear(year)}
          </div>
        </div>
      </div>

      {/* Table */}
      {loading ? (
        <div>Loading...</div>
      ) : (
        <div className="border rounded">
          {rows.map((row, i) => (
            <div
              key={row.leave_type_id}
              className="grid grid-cols-5 gap-2 p-2 border-b items-center"
            >
              <div>{row.name}</div>

              <div>
                {row.counts_against_allowance ? "Yes" : "No"}
              </div>

              <input
                type="number"
                className="border p-1"
                value={row.allowance_days || ""}
                disabled={!row.counts_against_allowance}
                onChange={(e) =>
                  updateRow(i, "allowance_days", e.target.value)
                }
              />

              <input
                type="number"
                className="border p-1"
                value={row.carry_over_days || ""}
                disabled={!row.counts_against_allowance}
                onChange={(e) =>
                  updateRow(i, "carry_over_days", e.target.value)
                }
              />

              <button
                className="bg-blue-600 text-white px-2 py-1 rounded"
                onClick={() => saveRow(row)}
                disabled={!row.counts_against_allowance}
              >
                Save
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}